import loadable from '@loadable/component';

export const SearchInternshipsPageLoadable = loadable(
  () => import('./SearchInternshipsPage'),
  { resolveComponent: (module) => module.SearchInternshipsPage },
);
